// Tín hiệu "phiên đã hết" toàn cục: tách việc báo khỏi việc chuyển trang để modal không bị
// tải lại trang làm biến mất. Một cờ duy nhất nên nhiều nguồn (401 đồng loạt, SessionEnded,
// refresh thất bại) chỉ mở một modal.
let open = false
const listeners = new Set<() => void>()

export const sessionExpiredStore = {
  subscribe(listener: () => void) {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
  getSnapshot: () => open,
  show() {
    if (open) return
    open = true
    for (const l of listeners) l()
  },
  hide() {
    if (!open) return
    open = false
    for (const l of listeners) l()
  },
}
